module.exports = __webpack_public_path__ + "static/media/validando_cuenta.0d1f12ea.png";